import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function If(_a) {
    var condition = _a.condition, children = _a.children;
    // return <></>;
    if (!condition)
        return _jsx(_Fragment, {});
    return _jsx(_Fragment, { children: children });
}
